var _excluded = ["disabled", "icon", "image", "isSelected"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { BrandSymbol } from '../../../components/dataDisplay';
import { Image } from '../../../components/media';
import { Icon } from '../../../foundations/Icon';
import { useBreakpoint } from '../../../theme';
import { isBrandSymbol } from '../../../theme/icons/utils';
import { forwardRef } from '../../../utils';
import { MenuItem } from '../../Menu/items/MenuItem';
import { jsx as _jsx } from "react/jsx-runtime";
export var SelectableItem = forwardRef((_ref, ref) => {
  var {
    disabled,
    icon,
    image,
    isSelected
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var {
    isExtraSmallScreen: isMobile
  } = useBreakpoint();
  var leftElement = icon ? isBrandSymbol(icon) ? /*#__PURE__*/_jsx(BrandSymbol, {
    type: icon,
    size: isMobile ? 'medium' : 'small',
    isDisabled: disabled === null || disabled === void 0 ? void 0 : disabled.isDisabled
  }) : /*#__PURE__*/_jsx(Icon, {
    type: icon,
    size: isMobile ? 'large' : 'small',
    color: "inherit",
    isDisabled: disabled === null || disabled === void 0 ? void 0 : disabled.isDisabled
  }) : image && /*#__PURE__*/_jsx(Image, {
    aspectRatio: "1 / 1",
    width: isMobile ? '20px' : '16px',
    src: image.src,
    alt: image.alt
  });
  return /*#__PURE__*/_jsx(MenuItem, _objectSpread(_objectSpread({
    "data-component": "Menu.SelectableItem"
  }, props), {}, {
    leftElement: leftElement,
    disabled: disabled,
    isSelected: isSelected,
    ref: ref
  }));
});
SelectableItem.displayName = 'Menu.SelectableItem';
//# sourceMappingURL=SelectableItem.js.map